import { render, staticRenderFns } from "./AddBillOfLading.vue?vue&type=template&id=3c1bd21d"
import script from "./AddBillOfLading.vue?vue&type=script&lang=js"
export * from "./AddBillOfLading.vue?vue&type=script&lang=js"
import style0 from "./AddBillOfLading.vue?vue&type=style&index=0&id=3c1bd21d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports